class NotaFiscal {
  public cnpj_prestador_servico?: string = '';
  public id?: string = '';
  public cnpj_contexto?: string = '';
  public codigo_contrato?: string | null = '';
  public codigo_ordem_compra?: string | null = '';
  public tipo_envio_nf?: 'X' | 'M' = 'X';
  public inscricao_municipal?: string = '';
  public razao_social?: string = '';
  public endereco?: string = '';
  public numero_endereco?: string = '';
  public bairro?: string = '';
  public codigo_municipio_endereco?: string | Number = 0;
  public uf_endereco?: string = '';
  public cep_endereco?: string = '';
  public telefone_contato?: string = '';
  public email_contato?: string = '';
  public numero_nf?: string = '';
  public codigo_verificacao?: string = '';
  public data_emissao_nf?: Date;
  public numero_identificacao_rps?: string = '';
  public serie_rps?: string = '';
  public tipo_rps?: string = '';
  public data_emissao_rps?: string = '';
  public natureza_operacao?: string = '';
  public regime_especial_tributacao?: string = '';
  public optante_simples_nacional?: string = '';
  public incentivador_cultural?: string = '';
  public data_competencia?: string = '';
  public valor_servico?: string = '';
  public iss_retido?: string = '';
  public valor_iss?: string = '';
  public valor_iss_retido?: string = '';
  public base_calculo?: string = '';
  public aliquota?: string = '';
  public valor_liquido_nf?: string = '';
  public codigo_item_lista_servico?: string = '';
  public codigo_tributacao_municipio?: string = '';
  public discriminacao_servico?: string = '';
  public validade_bloco?: string = '';
  public codigo_municipio_servico?: Number = 0;
  public codigo_municipio?: Number = 0;
  public uf_orgao_gerador?: string | Number = 0;
  public codigo_municipio_orgao_gerador?: Number | null = 0;
  public arquivo?: File | null = null;
  public subcontratada?: string = '';
  public cnpj_subcontratada?: string = '';
  public numero_nf_subcontratada?: string = '';
  public plano_basico?: string = '';
  public contrato_dts?: string = '';
  public pagamento_prioritario?: string = '';

  setFromParser({
    id,
    cnpj_prestador_servico,
    cnpj_contexto,
    inscricao_municipal,
    razao_social,
    endereco,
    numero_endereco,
    bairro,
    codigo_municipio_endereco,
    uf_endereco,
    cep_endereco,
    telefone_contato,
    email_contato,
    numero_nf,
    codigo_verificacao,
    data_emissao_nf,
    numero_identificacao_rps,
    serie_rps,
    tipo_rps,
    data_emissao_rps,
    natureza_operacao,
    regime_especial_tributacao,
    optante_simples_nacional,
    incentivador_cultural,
    data_competencia,
    valor_servico,
    iss_retido,
    valor_iss,
    valor_iss_retido,
    base_calculo,
    aliquota,
    valor_liquido_nf,
    codigo_item_lista_servico,
    codigo_tributacao_municipio,
    discriminacao_servico,
    codigo_municipio_servico,
    uf_orgao_gerador,
    codigo_municipio_orgao_gerador,
    codigo_municipio,
    arquivo,
    codigo_contrato,
    codigo_ordem_compra,
    validade_bloco,
    subcontratada,
    cnpj_subcontratada,
    numero_nf_subcontratada,
    plano_basico,
    contrato_dts,
    pagamento_prioritario,
  }: any): void {
    this.id = id == null ? '' : id;
    this.cnpj_prestador_servico =
      cnpj_prestador_servico == null ? '' : cnpj_prestador_servico;
    this.cnpj_contexto = cnpj_contexto == null ? '' : cnpj_contexto;
    this.inscricao_municipal =
      inscricao_municipal == null ? '' : inscricao_municipal;
    this.razao_social = razao_social == null ? '' : razao_social;
    this.endereco = endereco == null ? '' : endereco;
    this.numero_endereco = numero_endereco == null ? '' : numero_endereco;
    this.bairro = bairro == null ? '' : bairro;
    this.codigo_municipio_endereco =
      codigo_municipio_endereco == null ? '' : codigo_municipio_endereco;
    this.uf_endereco = uf_endereco == null ? '' : uf_endereco;
    this.cep_endereco = cep_endereco == null ? '' : cep_endereco;
    this.telefone_contato = telefone_contato == null ? '' : telefone_contato;
    this.email_contato = email_contato == null ? '' : email_contato;
    this.numero_nf = numero_nf == null ? '' : numero_nf;
    this.codigo_verificacao =
      codigo_verificacao == null ? '' : codigo_verificacao;
    this.data_emissao_nf = data_emissao_nf == null ? '' : data_emissao_nf;
    this.numero_identificacao_rps =
      numero_identificacao_rps == null ? '' : numero_identificacao_rps;
    this.serie_rps = serie_rps == null ? '' : serie_rps;
    this.tipo_rps = tipo_rps == null ? '' : tipo_rps;
    this.data_emissao_rps = data_emissao_rps == null ? '' : data_emissao_rps;
    if (natureza_operacao && ['1', '2'].includes(natureza_operacao)) {
      this.natureza_operacao = natureza_operacao;
    }
    this.regime_especial_tributacao =
      regime_especial_tributacao == null ? '' : regime_especial_tributacao;
    this.optante_simples_nacional =
      optante_simples_nacional == null ? '' : optante_simples_nacional;
    this.incentivador_cultural =
      incentivador_cultural == null ? '' : incentivador_cultural;
    this.data_competencia = data_competencia == null ? '' : data_competencia;
    this.valor_servico = valor_servico == null ? '' : valor_servico;
    this.iss_retido = iss_retido == null ? '' : iss_retido;
    this.valor_iss = valor_iss == null ? '' : valor_iss;
    this.valor_iss_retido = valor_iss_retido == null ? '' : valor_iss_retido;
    this.base_calculo = base_calculo == null ? '' : base_calculo;
    this.aliquota = aliquota == null ? '' : aliquota;
    this.valor_liquido_nf = valor_liquido_nf == null ? '' : valor_liquido_nf;
    this.codigo_item_lista_servico =
      codigo_item_lista_servico == null ? '' : codigo_item_lista_servico;
    this.codigo_tributacao_municipio =
      codigo_tributacao_municipio == null ? '' : codigo_tributacao_municipio;
    this.discriminacao_servico =
      discriminacao_servico == null ? '' : discriminacao_servico;
    this.codigo_municipio_servico = Number(codigo_municipio_servico);
    this.codigo_municipio = Number(codigo_municipio);
    this.uf_orgao_gerador = uf_orgao_gerador;
    this.codigo_contrato = codigo_ordem_compra ? codigo_contrato : '';
    this.validade_bloco = validade_bloco ? validade_bloco : '';
    this.codigo_ordem_compra = codigo_ordem_compra ? codigo_ordem_compra : '';
    this.codigo_municipio_orgao_gerador = Number(
      codigo_municipio_orgao_gerador,
    );
    this.arquivo = arquivo;
    this.subcontratada = subcontratada;
    this.cnpj_subcontratada = cnpj_subcontratada;
    this.numero_nf_subcontratada = numero_nf_subcontratada;
    this.plano_basico = plano_basico;
    this.contrato_dts = contrato_dts;
    this.pagamento_prioritario = pagamento_prioritario;
  }
}

export default NotaFiscal;
